<!-- 
화면명 : NCRList.vue
작성일 : 
설명   : NCR현황 화면
-->
<template>
  <div>
    <div class="relative bg-blueGray-100">

      <div class="flex justify-between mt-2">
        <div class="flex text-black font-bold text-lg items-center justify-center">
          <img src="@/assets/img/breadcrumbs.svg" class="w-4 h-4 mx-2" />
          NCR현황
        </div>
        <div class="flex mx-2">
          <UCButton label="조회" width="80px" icon="search" @click="btnSearchClick" />
          <UCButton label="엑셀" width="80px" icon="excel" @click="btnExcelClick" />
        </div>
      </div>

      <div class="bg-white p-1 rounded shadow mt-2 top-wrapper">
        <!-- <div class="flex text-blueGray-700 font-bold text-lg mb-4">
          <img src="@/assets/img/icon-search.svg" class="w-7 h-7" />
          조회 조건
        </div> -->

        <div
          class="w-full overflow-x-visible inline-flex flex-wrap items-center gap-x-6 gap-y-4 whitespace-nowrap px-4 py-2 border rounded bg-white shadow-sm"
        >
          <div class="flex space-x-2">
            <UCDate label="NCR처리일자" v-model="dtStart" />
            <span class="pt-2">&nbsp;~</span>
            <UCDate label="" v-model="dtEnd" />
          </div>

          <UCCombo
            label="NCR결과"
            v-model="cboResult.cd"
            :arrData="cboResult.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="120px"
          />

          <UCCombo
            label="판정코드"
            v-model="cboPanjung1.cd"
            :arrData="cboPanjung1.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="80px"
            @change="cboPanjung1change"
          />
          <UCCombo
            class="-ml-4"
            label=""
            v-model="cboPanjung2.cd"
            :arrData="cboPanjung2.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="120px"
          />

          <UCCombo
            label="판정결과"
            v-model="cboPanjungResult.cd"
            :arrData="cboPanjungResult.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="120px"
          />

          <div class="flex space-x-2">
            <UCDate label="조치일자" v-model="dtStartJochi" />
            <span class="pt-2">&nbsp;~</span>
            <UCDate label="" v-model="dtEndJochi" />
          </div>

          <UCCombo
            label="조치코드"
            v-model="cboJochi.cd"
            :arrData="cboJochi.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="100px"
          />

          <UCCombo
            label="관리코드"
            v-model="cboManage1.cd"
            :arrData="cboManage1.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="140px"
          />
          <UCCombo
            class="-ml-4"
            label=""
            v-model="cboManage2.cd"
            :arrData="cboManage2.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="100px"
          />

          <UCText v-show="false" label="불량부서" v-model="txtDept" width="100px" />

          <div class="flex items-center space-x-2">
            <UCVendor v-show="false"
              title="거래선"
              :VendCd="userStore.userVendCd"
              :VendName="userStore.userName"
            />
          </div>

          <UCText label="대상호선" v-model="txtShipNo" width="100px" />

          <UCText v-show="false" label="검사자" v-model="txtCheck" width="100px" />
        </div>
      </div>

      <!-- 소계 구분 -->
      <div class="mt-2 flex justify-between items-center">
        <label class="flex text-blueGray-600 text-base font-semibold whitespace-nowrap items-center justify-center" >
          <img src="@/assets/img/icon-list.svg" class="flex w-5 h-5 mr-2" />
          NCR 처리현황
        </label>

        <UCRadio
          label="소계구분"
          v-model="rdoSubTotalGubun.cd"
          :arrData="rdoSubTotalGubun.arr"
          code="value"
          name="label"
        />
      </div>

      <!-- 그리드 -->
      <div class="mt-2 mb-2">
        <UCGrid
          ref="refUcGrid"
          :data="arrSearchData"
          :isRowNumber="true"
          :columns="columns"
          :selectable="true"
          :pagination="true"
          :paginationSize="50"
          autoHeight
          :excludeSelectors="['.top-wrapper']"
          :heightOffset="60"
          @row-selected="handleSelection"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { format as formatDate } from "date-fns";
import { notify } from "@kyvg/vue3-notification";

import { useUserStore } from "@/store/userStore";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

import UCVendor from "@/components/UserControl/UCVendor.vue";
import UCGrid, { customFormatter } from "@/components/UserControl/UCGrid.vue";
import UCText from "@/components/UserControl/UCText.vue";
import UCCombo from "@/components/UserControl/UCCombo.vue";
import UCDate from "@/components/UserControl/UCDate.vue";
import UCRadio from "@/components/UserControl/UCRadio.vue";
import UCButton from "@/components/UserControl/UCButton.vue";

import { apiExecuteDataSet } from "@/api/SCM/common";

const userStore = useUserStore();

const dtStart = ref("");
const dtEnd = ref("");

const dtStartJochi = ref("");
const dtEndJochi = ref("");

const txtDept = ref("");
const txtShipNo = ref("");
const txtCheck = ref("");

// NCR결과
const cboResult = ref({
  cd: "",
  arr: [],
});

// 판정코드1
const cboPanjung1 = ref({
  cd: "",
  arr: [],
});
// 판정코드2
const cboPanjung2 = ref({
  cd: "",
  arr: [],
});

// 판정결과
const cboPanjungResult = ref({
  cd: "",
  arr: [],
});

// 조치코드
const cboJochi = ref({
  cd: "",
  arr: [],
});

// 관리코드1
const cboManage1 = ref({
  cd: "",
  arr: [],
});
// 관리코드2
const cboManage2 = ref({
  cd: "",
  arr: [],
});

// 소계 구분
const rdoSubTotalGubun = ref({
  cd: "A",
  arr: [
    { label: "전체", value: "A" },
    { label: "원인별", value: "B" },
    { label: "업체별", value: "C" },
    { label: "품명별", value: "D" },
    { label: "작업자별", value: "E" },
  ],
});

onMounted(() => {
  // console.log("mounted");

  bindCombo();

  btnSearchClick();
});

async function bindCombo() {
  // console.log("bindCombo");

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const today2 = new Date(year, 0, 1);
  dtStart.value = formatDate(today2, "yyyy-MM-dd");
  dtEnd.value = formatDate(today, "yyyy-MM-dd");

  const searchParams = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "NCRRESULT",
    },
  };

  const searchParams2 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "080",
    },
  };

  const searchParams3 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "081",
    },
  };

  const searchParams4 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "089",
    },
  };

  const searchParams5 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "BACTION",
    },
  };

  const searchParams6 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "087",
    },
  };

  const searchParams7 = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "088",
    },
  };

  const res = await Promise.all([
    apiExecuteDataSet(searchParams),
    apiExecuteDataSet(searchParams2),
    apiExecuteDataSet(searchParams3),
    apiExecuteDataSet(searchParams4),
    apiExecuteDataSet(searchParams5),
    apiExecuteDataSet(searchParams6),
    apiExecuteDataSet(searchParams7),
  ]);
  // console.log("res", res);

  cboResult.value.arr = res[0]._Result[0];
  cboResult.value.cd = "3";

  cboPanjung1.value.arr = res[1]._Result[0];
  cboPanjung1.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboPanjung1.value.cd = "";

  cboPanjung2.value.arr = res[2]._Result[0];
  cboPanjung2.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboPanjung2.value.cd = "";

  cboPanjungResult.value.arr = res[3]._Result[0];
  cboPanjungResult.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboPanjungResult.value.cd = "";

  cboJochi.value.arr = res[4]._Result[0];
  cboJochi.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboJochi.value.cd = "";

  cboManage1.value.arr = res[5]._Result[0];
  cboManage1.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboManage1.value.cd = "";

  cboManage2.value.arr = res[6]._Result[0];
  cboManage2.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboManage2.value.cd = "";
}

async function cboPanjung1change()
{
  const searchParams = {
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "08"+cboPanjung1.value.cd,
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  cboPanjung2.value.arr = res._Result[0];
  cboPanjung2.value.arr.unshift({ CMCD: "", CMCD_NAME: "전체" });
  cboPanjung2.value.cd = "";
}
async function btnSearchClick() {
  // console.log("btnSearchClick");

  const searchParams = {
    
    ID: "WERP\\TC05NCRR\\R002_OUT",
    Parameter: {
      "@T05NCRDATE_FR": dtStart.value.replaceAll("-", ""),
      "@T05NCRDATE_TO": dtEnd.value.replaceAll("-", ""),
      "@T05ACTDATE_FR": dtStartJochi.value.replaceAll("-", ""),
      "@T05ACTDATE_TO": dtEndJochi.value.replaceAll("-", ""),
      "@T05NCRCHK": cboResult.value.cd,
      "@T05BADCODE1": cboPanjung1.value.cd,
      "@T05BADCODE2": cboPanjung2.value.cd,
      "@T05RESULT": cboPanjungResult.value.cd,

      "@T05TESTER": txtCheck.value,
      "@T05BCUSNO": userStore.userVendCd,
      "@T05MAGCODE1": cboManage1.value.cd,
      "@T05MAGCODE2": cboManage2.value.cd,
      "@T05ACTION": cboJochi.value.cd,
      "@T05MCUSNO": "",
      "@T05WORKNO": txtShipNo.value,
      "@T05DWGNO": "",
      "@SUBTOTALGBN": "",
      "@EXCELGBN": "N",

      "@PAGENO": 1,
      "@PAGEINROW": 10000,
      "@SIDX": null,
      "@SORD": null,
      "@CURPAGE": null,
      "@MAXPAGE": null,
      "@TOTALCOUNT": null,
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  // console.log("res", res._Result);

  arrSearchData.value = res._Result[0];
}

const arrSearchData = ref([]);
const selectedRows = ref([]);
function handleSelection(data) {
  selectedRows.value = data;
  console.log("선택된 행:", data);
}

const columns = [
  {
    title: "",
    formatter: "rowSelection",
    titleFormatter: "rowSelection",
    hozAlign: "center",
    headerSort: false,
    width: 50,
  },
  { field: "NCRNO" , width: 120 , title: "NCR번호", hozAlign: "center" },
  { field: "T05NCRCHK" , width: 80 , title: "결과", hozAlign: "center" },
  { field: "T05BMATNA" , width: 200 , title: "부품명" , hozAlign: "left" },
  { field: "T05MCUSNM" , width: 120 , title: "거래선" , hozAlign: "left" },
  { field: "T05WORKNO" , width: 80 , title: "호선" , hozAlign: "left" },
  { field: "T05BADCODE" , width: 100 , title: "판정코드" , hozAlign: "center" },
  { field: "T05RESULT" , width: 100 , title: "판정결과" , hozAlign: "center" },
  { field: "T05MAGCODE" , width: 150 , title: "관리코드" , hozAlign: "center" },
  { field: "T05ACTION" , width: 80 , title: "조치코드" , hozAlign: "center" },
  {
    title: "첨부",
    field: "T05FGUID",
    width: 60,
    hozAlign: "center",
    headerSort: false,
    cellClick: (e, cell) => {
      const data = cell.getRow().getData();
      const guid = cell.getValue();
      if (guid && String(guid).trim() !== "") {
        openFileListPopup(guid, data);
      }
    },
    formatter: customFormatter("attachment"),
  },
  { field: "T05QCQTY" , width: 50 , title: "수량" , hozAlign: "right" },
  { field: "T05BADQTY" , width: 50 , title: "불량" , hozAlign: "right" },
  { field: "T05BADAMT" , width: 100 , title: "변상금액" , hozAlign: "right", formatter: "money", formatterParams: { thousand: ",", precision: 0, }, },
  { field: "T05DWGNO" , width: 150 , title: "도면번호" , hozAlign: "center" },
  { field: "T05GMATL" , width: 80 , title: "재질" , hozAlign: "center" },
  { field: "T05ACTDATE" , width: 100 , title: "조치일자" , hozAlign: "center" },
  { field: "T05FORDKEY" , width: 150 , title: "발주번호" , hozAlign: "center" },
];

async function btnExcelClick() {
  // console.log("btnExcelClick");

  // 다시 조회를 해서 가져오는게 나을지 확인 -> 조회랑 데이터가 달라서 다시 조회
  const searchParams = {
    
    ID: "WERP\\TC05NCRR\\R008",
    Parameter: {
      "@T05NCRDATE_FR": dtStart.value.replaceAll("-", ""),
      "@T05NCRDATE_TO": dtEnd.value.replaceAll("-", ""),
      "@T05NCRCHK": cboResult.value.cd,
      "@T05BADCODE1": cboPanjung1.value.cd,
      "@T05BADCODE2": cboPanjung2.value.cd,
      "@T05RESULT": cboPanjungResult.value.cd,
      "@T05ACTDATE_FR": dtStartJochi.value.replaceAll("-", ""),
      "@T05ACTDATE_TO": dtEndJochi.value.replaceAll("-", ""),
      "@T05BCUSNO": userStore.userVendCd,
      "@T05MAGCODE1": cboManage1.value.cd,
      "@T05MAGCODE2": cboManage2.value.cd,
      "@T05ACTION": cboJochi.value.cd,
      "@T05WORKNO": txtShipNo.value,
      "@T05BMATCD": "",
      "@T05DWGNO": "",
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  console.log("res", searchParams);

  if (res._Result[0].length === 0) {
    notify({
      title: "실패",
      text: "조회된 데이터 건수가 없습니다.",
      type: "error",
    });
    return;
  }

  const templatePath = "/excel/NCR현황.xlsx";
  const today = new Date();

  try {
    // 템플릿 파일 가져오기
    const response = await fetch(templatePath);
    const buffer = await response.arrayBuffer();

    // 워크북 로드
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    // 첫 번째 워크시트 선택
    const worksheet = workbook.getWorksheet(1);

    // 데이터 바인딩
    worksheet.getCell("A2").value = `처리일자 : ${
      dtStart.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(6, 8)
    } ~ ${
      dtEnd.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(6, 8)
    }`;
    worksheet.getCell("A3").value = `거래처 : ${
      userStore.userVendCd.substring(0, 3) +
      "-" +
      userStore.userVendCd.substring(4, 2) +
      "-" +
      userStore.userVendCd.substring(6)
    }`;

    worksheet.getCell("S2").value = `작성자 : ${userStore.userName}`;
    worksheet.getCell("S3").value = `출력일자 :  ${formatDate(
      today,
      "yyyy-MM-dd"
    )}`;

    // 테이블 데이터 바인딩
    const startRow = 7; // 데이터가 시작될 행 번호 (예: 6번째 행부터 시작)
    res._Result[0].forEach((item, index) => {
      // console.log("forEach", index, item);

      const row = worksheet.getRow(startRow + index);
      row.getCell(1).value = item.NCRNO;
      row.getCell(2).value = item.T05NCRCHK;
      row.getCell(3).value = item.T05BMATNA;
      row.getCell(4).value = item.T05MCUSNM;
      row.getCell(5).value = item.T05WORKNO;
      row.getCell(6).value = item.T05BADCODE;
      row.getCell(7).value = item.T05RESULT;
      row.getCell(8).value = item.T05MAGCODE;
      row.getCell(9).value = item.T05ACTION;
      row.getCell(10).value = item.T05QCQTY;
      row.getCell(11).value = item.T05BADQTY;
      row.getCell(12).value = item.T05BADAMT;
      row.getCell(13).value = item.T05DWGNO;
      row.getCell(14).value = item.T05GMATL;
      row.getCell(15).value = item.T05ACTDATE;
      row.getCell(16).value = item.T05WORKER;
      row.getCell(17).value = item.T05TESTER;
      row.getCell(18).value = item.T05FORDKEY;
      row.getCell(19).value = item.PRKEY;
    });

    // 합계 데이터 바인딩
    // worksheet.getCell('D' + (startRow + dataToBind.salesData.length)).value = dataToBind.totalSales;

    // 변경된 워크북을 버퍼로 변환
    const excelBuffer = await workbook.xlsx.writeBuffer();

    // 파일을 Blob으로 만들고 다운로드
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `NCR현황_${formatDate(today, "yyyyMMdd")}.xlsx`);

    notify({
      title: "성공",
      text: "엑셀 다운로드가 완료되었습니다.",
      type: "success",
    });
  } catch (error) {
    // console.error("엑셀 다운로드 중 오류 발생:", error);

    notify({
      title: "실패",
      text: "엑셀 다운로드에 실패했습니다." + error,
      type: "error",
    });
  }
}

// 첨부파일 뷰어 팝업 열기
let flistPopupWin = null;
function openFileListPopup(guid, rowData = {}) {
  if (!guid || String(guid).trim() === "") return;

  const ncrNo = rowData.NCRNO ? `[${rowData.NCRNO}] ` : "";
  const matName = rowData.T05BMATNA ? `${rowData.T05BMATNA}` : "";
  const title = `NCR 첨부파일 ${ncrNo}${matName}`.trim() || "NCR 첨부파일";
  const fmode = "READONLY";

  const width = 1250;
  const height = 720;
  const left = Math.max(0, (window.screen.width - width) / 2);
  const top = Math.max(0, (window.screen.height - height) / 2);
  const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`;

  const url = `/POPUP/flist?guid=${encodeURIComponent(guid)}&title=${encodeURIComponent(title)}&fmode=${encodeURIComponent(fmode)}&t=${Date.now()}`;

  flistPopupWin = window.open(url, "FListWindow", windowFeatures);
  if (flistPopupWin) {
    flistPopupWin.focus();
  }
}
</script>
